import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
// import jwt_decode from 'jwt-decode';
import jwtDecode from './../../services/jwt'
import { Redirect } from 'react-router'
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
const moment = require('moment');

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function PerfilForm({ history }) {

  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [roles, setRoles] = React.useState([]);
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [redirect, setRedirect] = React.useState(false);

  useEffect(() => {
    const { data } = jwtDecode(localStorage.getItem('token'))
    // const { data } = jwt_decode(localStorage.getItem('token'))
    setName(data.user.name);
    setEmail(data.user.email);
    const r = data.user.roles.map((ro)=> ro.description);
    setRoles(r);
  }, [])

  useEffect(() => {
    console.log('new version!')
  }, []);

  const save = async () => {
    const formDt = new FormData();
    formDt.append('name', name);
    formDt.append('email', email);
    formDt.append('_method', 'PUT');
    try { 
      const res = await api.post('/v1/profile/', formDt, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      });
      if(res.data.token){
        localStorage.setItem('token', res.data.token);
        setAlertTitle('')
        history.push('/')
      }else{
        setAlertTitle('Erro')
        setMessage('Erro ao atualizar perfil')
      }
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro ao atualizar perfil')
    }

  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      {/* TOPO */}
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} >
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        inputProps={{
                          disabled:true,
                          style: {
                            backgroundColor: '#F2F2F2',
                            cursor: 'not-allowed'
                          }
                        }}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} >
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="roles"
                        label="Grupos"
                        name="roles"
                        autoComplete="roles"
                        value={roles.join(',')}
                        inputProps={{
                          disabled:true,
                          style: {
                            backgroundColor: '#F2F2F2',
                            cursor: 'not-allowed'
                          }
                        }}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          window.history.back()
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        // className={classes.submit}
                        style={{ marginRight: 30 }}
                      >
                        Voltar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        // className={classes.submit}
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}